import { useConnectionStore } from '@/stores/connectionStore';

export function pickVoices(voices) {

  const connectionStore = useConnectionStore()  

  var playerVoiceNumber = -1
  var engineVoiceNumber = -1
  var samantha = -1
  var daniel = -1
  var googleUS = -1
  var googleUK = -1

  const playerVoiceName = connectionStore.getPlayerVoiceName
  const playerVoiceLang = connectionStore.getPlayerVoiceLang
  const opponentVoiceName = connectionStore.getOpponentVoiceName
  const opponentVoiceLang = connectionStore.getOpponentVoiceLang

  for (var i=0; i < voices.length; i++) {
    const oneVoice = voices[i]

    if (!oneVoice.lang.startsWith("en"))
      continue;

    //console.log("VOICE",oneVoice)

    // look for the user selected voices
    if (playerVoiceLang == oneVoice.lang && playerVoiceName == oneVoice.name)
      playerVoiceNumber = i
    if (opponentVoiceLang == oneVoice.lang && opponentVoiceName == oneVoice.name)
      engineVoiceNumber = i
    if (playerVoiceNumber >= 0 && engineVoiceNumber >= 0)
      break

    // find the default voices
    if (oneVoice.name == "Samantha" && oneVoice.lang == "en-US")
      samantha = i
    else
    if (oneVoice.name == "Daniel" && oneVoice.lang == "en-GB")
      daniel = i
    else
    if (oneVoice.name == "Google US English" && oneVoice.lang == "en-US")
      googleUS = i
    else
    if (oneVoice.name == "Google UK English Female" && oneVoice.lang == "en-GB")
      googleUK = i
  }

  if (playerVoiceNumber == -1) {
    if (samantha > -1)
      playerVoiceNumber = samantha
    else
    if (googleUS > -1)
      playerVoiceNumber = googleUS
  }

  if (engineVoiceNumber == -1) {
    if (daniel > -1)
      engineVoiceNumber = daniel
    else
      if (googleUK > -1)
        engineVoiceNumber = googleUK
  }
  return ([playerVoiceNumber,engineVoiceNumber])
}

export function getListofVoices(voicesFoundCallback) {
  var voices = []
  // https://stackoverflow.com/questions/21513706/getting-the-list-of-voices-in-speechsynthesis-web-speech-api/22978802#22978802

  const allVoicesObtained = new Promise(function(resolve, reject) {
    voices = window.speechSynthesis.getVoices();
    if (voices.length !== 0) {
      resolve(voices);
    } 
    else {
      window.speechSynthesis.addEventListener("voiceschanged", function() {
        voices = window.speechSynthesis.getVoices();
        resolve(voices);
      });
    }
  });

  allVoicesObtained.then(voices => {
    const voiceNumbers = pickVoices(voices)
    voicesFoundCallback(voices,voiceNumbers[0],voiceNumbers[1])
  })
}

export function voiceAddMicrophoneSupport(msg,whenDoneCallback) {
    msg.onstart = () => { 
      console.log('Speech started');
    }
    msg.onend = () => {
        console.log('Speech ended');
        whenDoneCallback("ended")
    }
    msg.onerror = (event) => {
      console.error('Speech error:', event.error);
      whenDoneCallback("error")
    }
    msg.onpause = () => {
      //console.log('Speech paused');
      whenDoneCallback("paused")
    }
    msg.onresume = () => {
      console.log('Speech resumed');
    }
  }